import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GetAllAccountPointsContext, GetAllAccountPointsState } from './get-all-account-points.types';

const getAllAccountPointsFeatureSelector = createFeatureSelector<GetAllAccountPointsState>('getAllAccountPoints');

export const selectGetAllAccountPointsLoading = createSelector(
  getAllAccountPointsFeatureSelector,
  state => state.default.loading
);

export const selectGetAllAccountPointsLoaded = createSelector(
  getAllAccountPointsFeatureSelector,
  state => state.default.loaded
);

export const selectGetAllAccountPoints = createSelector(
  getAllAccountPointsFeatureSelector,
  state => state.default.data
);

export const selectGetAllAccountPointsError = createSelector(
  getAllAccountPointsFeatureSelector,
  state => state.default.error
);

export const selectGetAllAccountPointsForContext = (context: GetAllAccountPointsContext) => createSelector(
  getAllAccountPointsFeatureSelector,
  state => state[context]?.data,
);

export const selectGetAllAccountPointsLoadingForContext = (context: GetAllAccountPointsContext) => createSelector(
  getAllAccountPointsFeatureSelector,
  state => state[context]?.loading ?? false,
);

export const selectGetAllAccountPointsLoadedForContext = (context: GetAllAccountPointsContext) => createSelector(
  getAllAccountPointsFeatureSelector,
  state => state[context]?.loaded ?? false,
);
